<div class="container container_type_main">
  <div class="page-control">
    <span (click)="back()" class="page-control__backlink with-icon">{{ 'back-to-tracks' | translate }}</span>
  </div>
  <div class="artist" *ngIf="melody">
    <div class="artist__add-favorite" (click)="toggleFavorite()">
      {{ 'melody.' + (melody.favorite ? 'added-to-favorite' : 'add-to-favorite') | translate }}
      <div [class.icon-star]="!melody.favorite" [class.icon-star-filled]="melody.favorite"></div>
    </div>

    <div class="artist__image">
      <img [src]="melody.pictureUrlBig" [alt]="melody.title" appReplaceMissingImage>

      <div class="player player_size_big" (click)="play()">
        <div class="player__button" [class.icon-play]="!melody.isPlaying" [class.icon-pause]="melody.isPlaying"></div>
        <div class="player__progressbar" #progressBar></div>
      </div>
    </div>

    <div class="artist__content">
      <div class="artist__name artist__name-with-favorite">
        {{melody.title}}
        <div class="icon-approved" *ngIf="purchased"></div>
      </div>
      <a class="artist__info" [routerLink]="'/artists/' + melody.artistId">{{melody.artistTitle}}</a>
      <div class="artist__controls">

        <div class="artist__control" *ngIf="!purchaseInProgress">
          <div class="button" [class.button_status_disabled]="purchased" (click)="purchaseMelody()">
            {{ (purchased ? 'melody-page.purchased' : 'melody-page.purchase') | translate }}
          </div>
        </div>

        <div class="artist__control" *ngIf="purchaseInProgress">
          <div class="button button_type_load"></div>
        </div>

        <div class="artist__control">
          <div class="button button_type_light" (click)="giftMelody()">
            {{ 'melody-page.gift' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="subtitle h2" *ngIf="recommendedMelodies?.length > 0 && melody">
    {{ 'melody-page.recommendations' | translate }}
  </div>
  <div class="songs-list" *ngIf="recommendedMelodies">
    <div *ngFor="let melody of recommendedMelodies" class="songs-list__item" app-melody-item [melody]="melody"></div>
  </div>

  <app-privet-plus-banner [specialBanners]="mainPageSpecialBanners"></app-privet-plus-banner>
</div>
